/**
 * BOTTOM-SHEET MOBILE « Choisir une taille » (cartes produit en collection)
 * --------------------------------------------------------------------------
 * Au tap sur le bouton « + » d'une carte (mobile), on ouvre un tiroir bas qui
 * reprend l'image, le titre, le prix et les tailles du produit affiché.
 * Les boutons de taille sont les <product-form> natifs (clonés) -> l'ajout au
 * panier et l'ouverture du tiroir panier restent gérés par le thème.
 *
 * NB : tant que le Palier 2 (tailles par couleur) n'est pas fait, le tiroir
 * reflète le produit de base de la carte.
 */
(function () {
  if (window.__cardSizeSheetInit) return;
  window.__cardSizeSheetInit = true;

  function getSheet() {
    return document.getElementById('CardSizeSheet');
  }

  function fillAndOpen(card) {
    var sheet = getSheet();
    if (!sheet || !card) return;

    // Image (reflète la couleur affichée) : on prend l'IMG primaire VISIBLE
    // (si la 1re média est une vidéo, on saute l'élément vidéo masqué).
    var imgs = card.querySelectorAll('img.product-card__image--primary');
    var cardImg = null;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].style.display !== 'none') { cardImg = imgs[i]; break; }
    }
    if (!cardImg && imgs.length) cardImg = imgs[0];
    var sheetImg = sheet.querySelector('.card-size-sheet__image');
    if (sheetImg) {
      sheetImg.removeAttribute('srcset');
      sheetImg.src = (cardImg && (cardImg.currentSrc || cardImg.src)) || '';
    }

    // Titre
    var cardTitle = card.querySelector('.product-title');
    var sheetTitle = sheet.querySelector('.card-size-sheet__title');
    if (sheetTitle) sheetTitle.textContent = cardTitle ? cardTitle.textContent.trim() : '';

    // Prix
    var cardPrice = card.querySelector('.price-list');
    var sheetPrice = sheet.querySelector('.card-size-sheet__price');
    if (sheetPrice) sheetPrice.innerHTML = cardPrice ? cardPrice.outerHTML : '';

    // Tailles : clone des <product-form> du sélecteur de la carte
    var cardSizes = card.querySelector('.product-card__floating-size-selector');
    var sheetSizes = sheet.querySelector('[data-card-sheet-sizes]');
    if (sheetSizes) {
      sheetSizes.innerHTML = '';
      if (cardSizes) {
        Array.prototype.forEach.call(cardSizes.children, function (node) {
          sheetSizes.appendChild(node.cloneNode(true));
        });
      }
    }

    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.documentElement.classList.add('card-size-sheet-open');
  }

  function closeSheet() {
    var sheet = getSheet();
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('card-size-sheet-open');
    var done = function () {
      if (!sheet.classList.contains('is-open')) sheet.hidden = true;
      sheet.removeEventListener('transitionend', done);
    };
    sheet.addEventListener('transitionend', done);
    setTimeout(done, 350);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.js-card-size-trigger');
    if (trigger) {
      e.preventDefault();
      fillAndOpen(trigger.closest('product-card'));
      return;
    }
    if (e.target.closest && e.target.closest('[data-card-sheet-close]')) {
      closeSheet();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  // À l'ajout au panier, on ferme le sheet : le tiroir panier prend le relais
  document.addEventListener('cart:change', closeSheet);
})();
